import { useEffect, useState } from "react";
import { ONBELLEK_OLAYI } from "./pwa-onbellek";

/**
 * Baglanti durumu.
 *
 * `navigator.onLine` YALNIZCA "ag arayuzu var mi" der; internet gercekten
 * calisiyor mu bilmez (otel wifi'si, captive portal). Bu yuzden false
 * degeri guvenilir, true degeri degildir. Kuyruk buna gore davranir:
 * cevrimdisi ise hic denemez, cevrimici ise dener ve basarisiz olursa
 * kaydi geri kuyruga koyar.
 */
export function useBaglantiDurumu(): boolean {
  const [cevrimici, setCevrimici] = useState(() =>
    typeof navigator === "undefined" ? true : navigator.onLine,
  );

  useEffect(() => {
    const acildi = (): void => setCevrimici(true);
    const kapandi = (): void => setCevrimici(false);
    window.addEventListener("online", acildi);
    window.addEventListener("offline", kapandi);
    return () => {
      window.removeEventListener("online", acildi);
      window.removeEventListener("offline", kapandi);
    };
  }, []);

  return cevrimici;
}

/**
 * Ekrandaki veri ağdan değil telefondaki önbellekten mi geldi.
 *
 * `useBaglantiDurumu`nun kör noktası: arayüz "çevrimiçi" derken sunucuya
 * ulaşılamıyorsa okumalar önbellekten dönüyor. Gerekçe `pwa-onbellek.ts`
 * içinde `ONBELLEK_OLAYI` notunda.
 */
export function useOnbellektenGosteriliyor(): boolean {
  const [onbellekten, setOnbellekten] = useState(false);
  useEffect(() => {
    const dinle = (e: Event): void => setOnbellekten((e as CustomEvent<boolean>).detail);
    window.addEventListener(ONBELLEK_OLAYI, dinle);
    return () => window.removeEventListener(ONBELLEK_OLAYI, dinle);
  }, []);
  return onbellekten;
}
